// extracted by mini-css-extract-plugin
module.exports = {"slide-sidebar":"sidebar_slide-sidebar__Vf_d0","sidebar-inner":"sidebar_sidebar-inner__GTWZn","show":"sidebar_show___RtVK"};